const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
const HAS_TIMEZONE = /(?:Z|[+-]\d{2}:?\d{2})$/;
const US_DATE = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

export function toApiDateTime(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const s = value.trim();
  if (!s) return null;

  if (DATE_ONLY.test(s)) return `${s}T00:00:00.000Z`;

  const normalized = HAS_TIMEZONE.test(s) ? s : `${s}Z`;
  const d = new Date(normalized);
  return isNaN(d.getTime()) ? null : d.toISOString();
}

export function dateOnly(value: string | null | undefined): string {
  return value ? value.slice(0, 10) : "";
}

export function toDateInput(value: string | null | undefined): string {
  if (!value) return "";
  const s = value.trim();
  const us = US_DATE.exec(s);
  if (us) {
    const [, m, d, y] = us;
    return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
  }
  const ymd = s.slice(0, 10);
  return DATE_ONLY.test(ymd) ? ymd : "";
}

export function formatDate(
  value: string | null | undefined,
  opts: Intl.DateTimeFormatOptions = { year: "numeric", month: "short", day: "numeric" },
): string {
  const ymd = dateOnly(value);
  if (!ymd) return "";
  const [y, m, d] = ymd.split("-").map(Number);
  if (!y || !m || !d) return "";
  return new Date(y, m - 1, d).toLocaleDateString(undefined, opts);
}

export function formatMonth(
  value: string | null | undefined,
  opts: Intl.DateTimeFormatOptions = { year: "numeric", month: "short" },
): string {
  if (!value) return "";
  const [y, m] = value.slice(0, 7).split("-").map(Number);
  if (!y || !m) return "";
  return new Date(y, m - 1, 1).toLocaleDateString(undefined, opts);
}

function parseDateTime(value: string | null | undefined): Date | null {
  if (!value) return null;
  const s = value.trim();
  if (!s) return null;
  const d = new Date(DATE_ONLY.test(s) || HAS_TIMEZONE.test(s) ? s : `${s}Z`);
  return isNaN(d.getTime()) ? null : d;
}

export function formatDateTime(
  value: string | null | undefined,
  opts: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  },
): string {
  const d = parseDateTime(value);
  return d ? d.toLocaleString(undefined, opts) : "";
}
